import { useSelector } from 'react-redux';
import activityThumb from '../../../assets/images/pkg-hotel-thmb.jpg';

const ActivityDetails = ({activityItem, resourceKeys}) => {
    const currency = useSelector(
        (state) => state.currencyDetails.currentCurrency
      );

    return (
        <>
            <div className="box_wrap SPdetWrap common_bdrBtm w-100 p-4">
                    <h4 className="SPdethead">{resourceKeys.your_activity || 'Your Activity'}</h4>
                    <div className="itenary-item">
                        <div className="itenary-head d-flex flex-wrap align-items-center">
                        <div className="itenary-day-label">{resourceKeys.Day || 'Day'} {activityItem.DayNo}</div>
                        <h3>{activityItem.City}</h3>
                        </div>
                        <div className="hotel-room-details">
                        <div className="row">
                            <div className="col-lg-1 col-md-2 col-4 hotel-room-thumb pl-0">
                            <img src={activityThumb} className="" />
                            </div>
                            <div className="col-lg-4 col-md-6 col-8 room-details-listing">
                            <h5>{activityItem?.ActivityName}</h5>
                            <span>{activityItem.Description}</span>
                            </div>
                            <div className="col-lg-2 col-md-6 col-6 d-flex align-items-center room-details-listing">
                            <ul className="spHtlDtls">
                                <li>
                                <i className="htladultIcon" />
                                <span>1 {resourceKeys.Adult || 'Adult'}</span>
                                </li>
                                <li>
                                <i className="htlchildIcon" />
                                <span>1 {resourceKeys.Child || 'Child'}</span>
                                </li>
                            </ul>
                            </div>
                            <div className="col-lg-3 col-md-6 col-6 d-flex align-items-center room-details-price">
                            <span>
                            {activityItem?.price > 0 && (
                                    <>
                                  <span>{currency}</span> <span>{activityItem?.price}</span>
                                  </>
                                )}
                            </span>
                            </div>
                            <div className="col-lg-2 col-md-6 col-sm-6 d-flex align-items-center justify-content-end room-select pr-0">
                            {/* <span className="theme_btnStyle ">{resourceKeys.Selected || 'Selected'}</span> */}
                            </div>
                        </div>
                        </div>
                    </div>
                    </div>
        </>
    );
}

export default ActivityDetails;
